import React, { createContext, useState, useContext } from 'react';

const AutoSaveContext = createContext();

export const useAutoSave = () => {
  const context = useContext(AutoSaveContext);
  if (!context) {
    return { autoSaving: false, lastSaved: null, setAutoSaving: () => {}, setLastSaved: () => {} };
  }
  return context;
};

export const AutoSaveProvider = ({ children }) => {
  const [autoSaving, setAutoSaving] = useState(false);
  const [lastSaved, setLastSaved] = useState(null);

  return (
    <AutoSaveContext.Provider value={{ autoSaving, lastSaved, setAutoSaving, setLastSaved }}>
      {children}
    </AutoSaveContext.Provider>
  );
};
